export default "__VITE_ASSET__$xNvlBg7__"